// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"78a87e08","703":"71a863c7"}[chunkId] + ".chunk.js";
};